@if (clientTips) {
  <mat-nav-list>
    <h3 class="subheader">Cliëntspecifieke tips</h3>
    @for (tip of clientTips; track getClientTipId($index, tip); let isLast = $last) {
      <mat-list-item (click)="onTipClick(tip)">
        <mat-icon matListItemIcon>{{tip.getAuteurRol() | zahRolIcon}}</mat-icon>
        <div matListItemTitle>{{tip.getContent()}}</div>
        <div matListItemLine class="mat-small">
          {{tip.getAuteurRol()}}
        </div>
        <button matListItemMeta
          class="center-vertically"
          [disableRipple]="true"
          [class.hidden]="!tip.isEditableBy(user) && !tip.isDeletableBy(user)"
          mat-icon-button
          [matMenuTriggerFor]="menu"
          (click)="$event.stopPropagation()">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu"
          xPosition="before"
          overlapTrigger="true">
          @if (tip.isEditableBy(user)) {
            <a
              mat-menu-item
              (click)="onEditClick(tip)">
              <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
              <span>Wijzigen</span>
            </a>
          }
          @if (tip.isDeletableBy(user)) {
            <a
              mat-menu-item
              (click)="onDeleteClick(tip)">
              <mat-icon fontSet="material-icons-outlined">delete</mat-icon>
              <span>Verwijderen</span>
            </a>
          }
        </mat-menu>
      </mat-list-item>
      @if (!isLast) {
        <mat-divider></mat-divider>
      }
    }
    @if (clientTips.length === 0) {
      <mat-list-item
        class="no-list-item-highlight"
        disableRipple>
        <div matListItemTitle>Geen tips voor deze cliënt</div>
      </mat-list-item>
    }
    <mat-divider></mat-divider>
    <mat-list-item class="no-list-item-highlight overflow-visible-for-button-shading"
      disableRipple
      lines="2">
      <span matListItemMeta class="center-vertically">
        <button mat-mini-fab
          color="accent"
          (click)="onAddClick()">
          <mat-icon>add</mat-icon>
        </button>
      </span>
    </mat-list-item>
  </mat-nav-list>
}
